module.exports = __webpack_public_path__ + "img/cover.fae9e351.png";